import { Component } from 'react';

import FormInputComponent from '../../../components/ui/forms/form-input/form-input.component';
import Modal from '../../../components/ui/modal/modal.component';
import { FormControl } from '../../../models/forms';
import { IconHelper } from '../../../utils/icon-helper';
import { HtmlEntityTypes } from '../../../utils/icon.utils';

export interface MemeShareModalComponentProps {
    url: string;
    downlaodFile: (title: string) => void;
}

export class MemeShareModalComponent extends Component<MemeShareModalComponentProps> {
    titleCtrl = new FormControl('Image Title');

    static show(props: MemeShareModalComponentProps) {
        Modal.createModal(MemeShareModalComponent, props);
    }

    constructor(props: MemeShareModalComponentProps) {
        super(props);
    }

    openFacebookWindow(event: MouseEvent) {
        window.open(`https://www.facebook.com/sharer/sharer.php?u=${encodeURI(this.props.url)}&display=popup&ref=plugin&src=share_button`
            , 'Facebook', 'width=640,height=580');
        event.preventDefault();
        event.stopPropagation();
    }

    openTwitterWindow(event: MouseEvent) {
        if (!this.titleCtrl.value) {
            this.titleCtrl.setValue('Shared an image');
        }
        const title = this.titleCtrl.value;
        const enc = encodeURI(title + ' ' + this.props.url);
        window.open(`https://twitter.com/intent/tweet?text=${enc}`
            , 'Twitter', 'width=640,height=580');
        event.preventDefault();
        event.stopPropagation();
    }

    openReditWindow(event: MouseEvent) {
        if (!this.titleCtrl.value) {
            this.titleCtrl.setValue('Shared an image');
        }
        const title = this.titleCtrl.value;
        window.open(`https://www.reddit.com/submit?url=${encodeURI(this.props.url)}&title=${encodeURI(title)}`
            , 'Redit', 'width=640,height=580');
        event.preventDefault();
        event.stopPropagation();
    }

    render() {
        return <Modal>
            <div data-modalheader>
                <h2>Share Meme</h2>
            </div>
            <div data-modalbody>
                <div className="modal-body meme-share-container">
                    <div className="row">
                        <div className="col-xs-12 col-12">
                            <div className="form-group row">
                                <label htmlFor="inputPassword" className="col-sm-12 col-form-label">Title/Description</label>
                                <div className="col-sm-12">
                                    <FormInputComponent control={this.titleCtrl} className="form-control"
                                        type='text' placeholder="Enter text..." id="inputPassword"></FormInputComponent>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="row">
                        <br />
                        <div className="col-xs-12 col-12">
                            <div className="form-group row">
                                <label htmlFor="sharableLink" className="col-sm-3 col-form-label">Share Url</label>
                                <div className="col-sm-9 break-all">
                                    {this.props.url}
                                </div>
                            </div>
                        </div>
                        <br />
                        <div className="col-xs-12 col-12">
                            <div className="form-group row">
                                <label htmlFor="sharableLink" className="col-sm-3 col-form-label">Easy Share</label>
                                <div className="col-sm-9">
                                    <button className="btn btn-primary share-btn facebook-share-btn" onClick={($event) => this.openFacebookWindow($event as any)}>
                                        Facebook Share
                                    </button>
                                    <button className="btn btn-primary share-btn twitter-share-button" data-size="large"
                                        onClick={($event) => this.openTwitterWindow($event as any)}>
                                        Tweet Share
                                    </button>

                                    <button className="btn btn-primary share-btn redit-share-button" data-size="large"
                                        onClick={($event) => this.openReditWindow($event as any)}>
                                        Redit Share
                                    </button>
                                </div>
                            </div>
                        </div>

                        <br />
                        <div className="col-xs-12 col-12">
                            <div className="form-group row">
                                <label htmlFor="sharableLink" className="col-sm-3 col-form-label">Download Meme</label>
                                <div className="col-sm-9">
                                    <button className="btn btn-primary facebook-share-btn" onClick={($event) => this.props.downlaodFile(this.titleCtrl.value)}>
                                        {
                                            IconHelper.getIconElement(HtmlEntityTypes.ARROW_DOWN)
                                        }
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </Modal>
    }
}
